import { Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useRef, useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';

interface TruncatedTextProps {
  text: string;
  maxWidth?: number | string | object;
  sx?: object;
  variant?: any;
}

export default function TruncatedText({
  text,
  maxWidth,
  sx = {},
  variant = 'subtitle2'
}: TruncatedTextProps) {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [open, setOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (textRef.current) {
      const { scrollWidth, clientWidth } = textRef.current;
      setIsTruncated(scrollWidth > clientWidth);
    }
  }, [text]);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const { scrollWidth, clientWidth } = textRef.current;
        setIsTruncated(scrollWidth > clientWidth);
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [text]);

  const typography = (
    <Typography
      ref={textRef}
      noWrap
      variant={variant as any}
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        maxWidth: maxWidth ?? { xs: 200, sm: 'none' },
        cursor: isMobile && isTruncated ? 'pointer' : 'default',
        ...sx
      }}
      onClick={() => {
        if (isMobile && isTruncated) setOpen((prev) => !prev);
      }}
    >
      {text}
    </Typography>
  );

  return isTruncated ? (
    <Tooltip
      title={text}
      open={isMobile ? open : undefined} // en mobile lo controlamos manualmente
      onClose={() => setOpen(false)}
    >
      {typography}
    </Tooltip>
  ) : (
    typography
  );
}
